import { render, staticRenderFns } from "./RoomItems.vue?vue&type=template&id=6430eeeb"
import script from "./RoomItems.vue?vue&type=script&lang=js"
export * from "./RoomItems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports